unit unit_Nachrichten;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Grids, Data.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,
  WEBLib.ExtCtrls, DB;

type
  TNachrichten = class(TForm)
    TC: TTableControl;
    xdsNachrichten: TXDataWebDataSet;
    xdsNachrichtenID: TIntegerField;
    xdsNachrichtenKundennummer: TStringField;
    xdsNachrichtenDatum: TDateTimeField;
    xdsNachrichtenBetreff: TStringField;
    xdsNachrichtenNachricht: TStringField;
    xdsNachrichtenGelesenAm: TDateTimeField;
    xdsNachrichtenNachname: TStringField;
    procedure WebFormShow(Sender: TObject);
    procedure xdsNachrichtenAfterOpen(DataSet: TDataSet);
    procedure xdsNachrichtenAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsNachrichtenAfterPost(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    btnGelesen:TButton;
    buttonzurueck:TButton;
    procedure btnGelesenclick(Sender:TObject);
    procedure buttonzurueckclick(Sender:TObject);
    procedure Formularaktualisieren;
  protected procedure LoadDFMValues; override; end;

var
  Nachrichten: TNachrichten;

implementation
  uses unit1, unit2;
{$R *.dfm}




procedure TNachrichten.buttonzurueckclick(Sender:TObject);
begin
  close;
end;

procedure TNachrichten.btnGelesenClick(Sender: TObject);
begin

  xdsNachrichten.Locate('ID',inttostr(btnGelesen.Tag),[]);

  xdsNachrichten.edit;
  xdsNachrichtenGelesenAm.asdatetime:=date+time;
  xdsNachrichten.Post;
end;

procedure TNachrichten.Formularaktualisieren;
var
  i:integer;
  myelement:TJSHTMLElement;
  NRTEXT:string;
begin
  tc.RowCount:=xdsnachrichten.RecordCount+3;
  i:=1;
  xdsnachrichten.First;
  while not xdsnachrichten.eof do
  begin
    inc(i);
    NRTEXT:='<h5>'+formatdatetime('DD.MM.YYYY',xdsnachrichtendatum.Asdatetime);
    NRTEXT:=NRTEXT+'<b> '+xdsNachrichtenbetreff.asstring+'</b></h5>';
    NRTEXT:=NRTEXT+''+xdsNachrichtenNachricht.asstring;
    if xdsnachrichtengelesenam.AsString<>'' then
    begin
      NRTEXT:=NRTEXT+'<br><i>gelesen am: '+formatdatetime('DD.MM.YYYY',xdsnachrichtengelesenam.Asdatetime);
      tc.Cells[0,i]:=NRTEXT;
    end
    else
    begin
      tc.Cells[0,i]:=NRTEXT+'<br><p>';
      myelement:=TC.cellelements[0,i];
      btnGelesen:=TButton.Create(self);
      btnGelesen.ElementClassName:='btn btn-info text-left';
      btnGelesen.HeightStyle:=ssauto;
      btnGelesen.WidthStyle:=ssauto;
      btnGelesen.tag:=xdsnachrichtenid.AsInteger;
      btnGelesen.Caption:='als GELESEN markieren';
      btnGelesen.OnClick:=@btnGelesenclick;
      btnGelesen.ParentElement:=myelement;
    end;

    xdsNachrichten.Next;
  end;

  buttonzurueck.setfocus;
end;

procedure TNachrichten.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  TC.ColCount:=1;
  tc.RowCount:=5;
  TC.Cells[0,0]:='<h4>Nachrichten';
  myelement:=TC.cellelements[0,1];
  buttonzurueck:=TButton.Create(self);
  buttonzurueck.ElementClassName:='btn btn-info text-left';
  buttonzurueck.HeightStyle:=ssauto;
  buttonzurueck.WidthStyle:=ssauto;
  buttonzurueck.tag:=0;
  buttonzurueck.Caption:='<< zurück';
  buttonzurueck.OnClick:=@buttonzurueckClick;
  buttonzurueck.ParentElement:=myelement;
  xdsNachrichten.Close;
  xdsNachrichten.QueryString:='$filter=Kundennummer eq '+QuotedStr(KundeKundennummer)+'&$orderby=ID desc';
  xdsNachrichten.Load;
end;

procedure TNachrichten.xdsNachrichtenAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  if info.Records[0].Error='' then
  begin
    Formularaktualisieren;
  end;

end;

procedure TNachrichten.xdsNachrichtenAfterOpen(DataSet: TDataSet);
begin
  Formularaktualisieren;

end;

procedure TNachrichten.xdsNachrichtenAfterPost(DataSet: TDataSet);
begin
  xdsnachrichten.ApplyUpdates;
end;

procedure TNachrichten.LoadDFMValues;
begin
  inherited LoadDFMValues;

  TC := TTableControl.Create(Self);
  xdsNachrichten := TXDataWebDataSet.Create(Self);
  xdsNachrichtenID := TIntegerField.Create(Self);
  xdsNachrichtenKundennummer := TStringField.Create(Self);
  xdsNachrichtenDatum := TDateTimeField.Create(Self);
  xdsNachrichtenBetreff := TStringField.Create(Self);
  xdsNachrichtenNachricht := TStringField.Create(Self);
  xdsNachrichtenGelesenAm := TDateTimeField.Create(Self);
  xdsNachrichtenNachname := TStringField.Create(Self);

  TC.BeforeLoadDFMValues;
  xdsNachrichten.BeforeLoadDFMValues;
  xdsNachrichtenID.BeforeLoadDFMValues;
  xdsNachrichtenKundennummer.BeforeLoadDFMValues;
  xdsNachrichtenDatum.BeforeLoadDFMValues;
  xdsNachrichtenBetreff.BeforeLoadDFMValues;
  xdsNachrichtenNachricht.BeforeLoadDFMValues;
  xdsNachrichtenGelesenAm.BeforeLoadDFMValues;
  xdsNachrichtenNachname.BeforeLoadDFMValues;
  try
    Name := 'Nachrichten';
    Width := 160;
    Height := 367;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 0;
    TC.Width := 137;
    TC.Height := 329;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 2;
    xdsNachrichten.SetParentComponent(Self);
    xdsNachrichten.Name := 'xdsNachrichten';
    xdsNachrichten.AfterApplyUpdates := xdsNachrichtenAfterApplyUpdates;
    xdsNachrichten.AfterOpen := xdsNachrichtenAfterOpen;
    xdsNachrichten.AfterPost := xdsNachrichtenAfterPost;
    xdsNachrichten.EntitySetName := 'KundenportalNachrichten';
    xdsNachrichten.Connection := DM2.XDataWebConnection1;
    xdsNachrichten.Left := 24;
    xdsNachrichten.Top := 48;
    xdsNachrichtenID.SetParentComponent(xdsNachrichten);
    xdsNachrichtenID.Name := 'xdsNachrichtenID';
    xdsNachrichtenID.FieldName := 'ID';
    xdsNachrichtenKundennummer.SetParentComponent(xdsNachrichten);
    xdsNachrichtenKundennummer.Name := 'xdsNachrichtenKundennummer';
    xdsNachrichtenKundennummer.FieldName := 'Kundennummer';
    xdsNachrichtenKundennummer.Size := 13;
    xdsNachrichtenDatum.SetParentComponent(xdsNachrichten);
    xdsNachrichtenDatum.Name := 'xdsNachrichtenDatum';
    xdsNachrichtenDatum.FieldName := 'Datum';
    xdsNachrichtenBetreff.SetParentComponent(xdsNachrichten);
    xdsNachrichtenBetreff.Name := 'xdsNachrichtenBetreff';
    xdsNachrichtenBetreff.FieldName := 'Betreff';
    xdsNachrichtenBetreff.Size := 75;
    xdsNachrichtenNachricht.SetParentComponent(xdsNachrichten);
    xdsNachrichtenNachricht.Name := 'xdsNachrichtenNachricht';
    xdsNachrichtenNachricht.FieldName := 'Nachricht';
    xdsNachrichtenNachricht.Size := 255;
    xdsNachrichtenGelesenAm.SetParentComponent(xdsNachrichten);
    xdsNachrichtenGelesenAm.Name := 'xdsNachrichtenGelesenAm';
    xdsNachrichtenGelesenAm.FieldName := 'GelesenAm';
    xdsNachrichtenNachname.SetParentComponent(xdsNachrichten);
    xdsNachrichtenNachname.Name := 'xdsNachrichtenNachname';
    xdsNachrichtenNachname.FieldName := 'Nachname';
    xdsNachrichtenNachname.Size := 40;
  finally
    TC.AfterLoadDFMValues;
    xdsNachrichten.AfterLoadDFMValues;
    xdsNachrichtenID.AfterLoadDFMValues;
    xdsNachrichtenKundennummer.AfterLoadDFMValues;
    xdsNachrichtenDatum.AfterLoadDFMValues;
    xdsNachrichtenBetreff.AfterLoadDFMValues;
    xdsNachrichtenNachricht.AfterLoadDFMValues;
    xdsNachrichtenGelesenAm.AfterLoadDFMValues;
    xdsNachrichtenNachname.AfterLoadDFMValues;
  end;
end;

end.
